import {
  defineComponent,
  computed,
} from 'vue';
import { getStylesBinder } from '~mall/common/utils/styles';
import styles from './index.module.less';

const cx = getStylesBinder(styles);

/** 奖励金图标地址 */
const REWARD_ICON_URL = 'https://m.hellobike.com/a57730c342.svg';

export default defineComponent({
  name: 'RewardBar',
  props: {
    /** 奖励金数量 */
    points: {
      type: Number,
      default: 0,
    },
    /** 可抵扣金额 */
    amount: {
      type: Number,
      default: 0,
    },
    /** 开关状态 */
    switchOn: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['switch-change'],
  setup(props, { emit }) {
    // 营销条文案 - 金额部分
    const amountText = computed(() => `¥${props.amount}`);


    // 开关切换
    const handleSwitch = (val: boolean) => {
      emit('switch-change', val);
    };

    return {
      amountText,
      handleSwitch,
    };
  },
  render() {
    return (
      <div class={cx('reward-bar-box')}>
        <div class={cx('reward-bar')}>
          <img
            class={cx('reward-bar__icon')}
            src={REWARD_ICON_URL}
            alt="奖励金"
          />
          <span class={cx('reward-bar__text')}>
            开启奖励金抵扣，最高抵
            <span class={cx('reward-bar__amount')}>{this.amountText}</span>
          </span>
          <van-switch
            class={cx('reward-bar__switch')}
            value={this.switchOn}
            size="20px"
            active-color="#0088FF"
            inactive-color="#D3DAE0"
            {...{
              on: {
                input: this.handleSwitch,
              },
            }}
          />
        </div>
      </div>
    );
  },
});
